"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const assert = require('assert').strict;
const { resolveExpression } = require('../evaluate');
const { OR } = require('../definitions/operators');
exports.accepts = ({ operator }) => operator === OR;
exports.resolve = ({ operands }, context) => __awaiter(void 0, void 0, void 0, function* () {
    assert(context);
    assert(Array.isArray(operands));
    assert(operands.length > 0);
    if (operands.length === 1) {
        return resolveExpression(operands[0], context);
    }
    const result = yield resolveExpression(operands[0], context);
    // Exit early if any result is true
    if (result) {
        return true;
    }
    const tail = operands.slice(1);
    return exports.resolve({ operands: tail }, context);
});
//# sourceMappingURL=orExpression.js.map